export default "__VITE_ASSET__DqS1ss6G__"